import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import congratulation from "./../../../Images/congratulation-img.png";
import "./HowtoAlgoBulls.css";
function HowtoAlgoBulls(props) {
 // console.log(props);
  return (
    <>
      <section className="howtostart_section howtoalgobulls">
        <div className="howtostart_main">
        <div className="container">
          <div class="page_heading"><h2><span>How to Start</span></h2></div>
          <div className="row justify-content-center">
            <div className="col-md-11">
              <div className="howtostart_grid">
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_icon">
                      <span>1</span>
                    </div>
                    <div className="howtostart_text media-body">
                      <h3>Get Started</h3>
                      <p>Sign Up/Login to your account. Search out for the strategy.</p>
                    </div>
                  </div>
                </div>
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_text media-body">
                      <h3>Select Strategy</h3>
                      <p> Choose from a wide range of<strong> <a href="https://app.algobulls.com/marketplace/category/retail?displayMode=0&query=eyJjdXJyZW50UGFnZSI6MSwicGFnZVNpemUiOjh9">strategies</a></strong>.</p>
                    </div>
                    <div className="howtostart_icon">
                      <span>2</span>
                    </div>
                  </div>
                </div>
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_icon">
                      <span>3</span>
                    </div>
                    <div className="howtostart_text media-body">
                      <h3>Select a Plan</h3>
                      <p> Pick the right AlgoBulls subscription plan for yourself.</p>
                    </div>
                  </div>
                </div>
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_text media-body">
                      <h3>Add a Broker</h3>
                      <p> Add Moneysukh  broker to your AlgoBulls account.</p>
                    </div>
                    <div className="howtostart_icon">
                      <span>4</span>
                    </div>
                  </div>
                </div>
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_icon">
                      <span>5</span>
                    </div>
                    <div className="howtostart_text media-body">
                      <h3>Start Trading</h3>
                      <p> With all the parameters set, you can now start trading!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      <section className="congratulation_section">
        <div className="container">
          <div class="page_heading"><h2>Congratulations!</h2></div>
          <div className="congratulation_text text-center">
            <div className="congratulation_img">
              <img className="img-fluid" src={congratulation} alt="congratulation" />
            </div>
            <h3>You've just put your first AlgoBulls <br></br>strategy into action.</h3>
          </div>
        </div>
      </section>
      <section className="ctest_section py-5 d-none">
        <div className="container">
          <div class="page_heading"><h2>fgfdf!</h2></div>
          <div className="congratulation_text text-center">
            <div className="congratulation_img">
              <img className="img-fluid" src={congratulation} alt="congratulation" />
            </div>
            <h3>You've just put your first <br></br>AlgoBulls strategy into action.</h3>
          </div>
        </div>
      </section>
    </>
  );
}
export default HowtoAlgoBulls;
